import React from 'react';
import { ArrowRight, Calendar } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function CTAFooter() {
  return (
    <section
      data-testid="cta-footer-section"
      className="relative py-20 md:py-28 bg-slate-900 overflow-hidden"
      aria-label="Call to action"
    >
      {/* Decorative elements */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-[#4AC5DB]/5 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-[300px] h-[300px] bg-[#4AC5DB]/3 rounded-full blur-3xl" />
      </div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2
          data-testid="cta-heading"
          className="font-['Outfit'] text-3xl md:text-5xl font-semibold text-white tracking-tight mb-4"
        >
          Ready to Amplify Your B2B Content Reach?
        </h2>
        <p className="text-base md:text-lg text-slate-400 leading-relaxed max-w-2xl mx-auto mb-10">
          Partner with iTMunch, a leading B2B content syndication service provider, and start generating qualified leads today.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a href="#hero">
            <Button
              data-testid="cta-get-started-button"
              className="rounded-full bg-[#4AC5DB] hover:bg-[#3AB0C5] text-white px-8 h-13 text-base font-semibold shadow-lg shadow-[#4AC5DB]/20 transition-all hover:-translate-y-0.5 active:scale-[0.98]"
            >
              Get Started Now <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </a>
          <a
            href="https://calendly.com/simon-p-itmunch/30min"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button
              data-testid="cta-schedule-button"
              variant="outline"
              className="rounded-full border-2 border-slate-600 hover:border-[#4AC5DB] text-slate-300 hover:text-[#4AC5DB] px-8 h-13 text-base font-semibold transition-all"
            >
              <Calendar className="w-5 h-5 mr-2" /> Schedule a Call
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
}
